import { sendGTMEvent } from '@next/third-parties/google'
import type { IAnalyticsAdapter, TAnalyticsEvent } from './types'

export const GoogleTagManagerAdapter: IAnalyticsAdapter = {
  trackEvent: ({ name, properties }: TAnalyticsEvent) => {
    if (typeof window === 'undefined') return
    sendGTMEvent({ event: name, ...properties })
  },
}
